import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { SalatiActivationRequest } from '../api/salati/salatiactivation/salatiactivationrequest';
import { SalatiActivationResponse, SalatiActivationResponseDtoImpl } from '../api/salati/salatiactivation/salatiactivationresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';

export class SalatiActivationAPIProcessorImpl extends SixdeeCRBTAPIProcessor<SalatiActivationRequest, SalatiActivationResponse>
{
    execute(request: SalatiActivationRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new SalatiActivationResponseDtoImpl(APIFeatures.SALATI_ACTIVATION, "Salati Activation Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new SalatiActivationResponseDtoImpl(APIFeatures.SALATI_ACTIVATION, "Internal Server Error"));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);

            this.getAPIFailure(new SalatiActivationResponseDtoImpl(APIFeatures.SALATI_ACTIVATION, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/salatiactivationapiprocessor.tsx